(function () {
  const root = document.querySelector("[data-wlk-mega]");
  if (!root) return;

  const menuItems = root.querySelectorAll("[data-nav-item]");
  let overlay = document.querySelector("[data-wlk-overlay]") || root.querySelector("[data-wlk-overlay]");
  const drawer = root.querySelector("[data-wlk-drawer]");
  const drawerOpenBtns = document.querySelectorAll("[data-wlk-drawer-open]");
  const drawerCloseBtn = root.querySelector("[data-wlk-drawer-close]");
  const header = document.querySelector(".section-header") || document.querySelector(".header-wrapper");
  let closeTimer = null;
  let drawerOpen = false;

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "wlk-mega-overlay";
    overlay.setAttribute("data-wlk-overlay", "");
  }
  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  function setHeaderMetrics() {
    const nav = root.querySelector(".wlk-mega__nav");
    const headerEl = document.querySelector("sticky-header") || header;
    const headerBottom = headerEl ? Math.round(headerEl.getBoundingClientRect().bottom) : 0;
    const navBottom = nav && nav.offsetParent ? Math.round(nav.getBoundingClientRect().bottom) : headerBottom;
    document.documentElement.style.setProperty("--wlk-header-height", `${Math.max(headerBottom, 0)}px`);
    document.documentElement.style.setProperty("--wlk-mega-top", `${Math.max(navBottom, headerBottom, 0)}px`);
    const top = Math.max(navBottom, headerBottom, 0);
    if (!drawerOpen) {
      document.documentElement.style.setProperty("--wlk-drawer-top", `${top}px`);
      return;
    }
    const drawerTop = getDrawerTop();
    document.documentElement.style.setProperty("--wlk-drawer-top", `${drawerTop}px`);
    document.documentElement.style.setProperty("--wlk-overlay-top", `${drawerTop}px`);
  }

  function getDrawerTop() {
    const nav = root.querySelector(".wlk-mega__nav");
    const headerEl = document.querySelector("sticky-header") || header;
    const headerBottom = headerEl ? Math.round(headerEl.getBoundingClientRect().bottom) : 0;
    const navStyle = nav ? window.getComputedStyle(nav) : null;
    const navVisible = nav && navStyle && navStyle.display !== "none" && navStyle.visibility !== "hidden";
    if (navVisible) {
      return Math.max(Math.round(nav.getBoundingClientRect().bottom), headerBottom, 0);
    }
    return Math.max(headerBottom, 0);
  }

  function getPinHeight() {
    const headerSection = document.querySelector("#shopify-section-header") || document.querySelector(".section-header");
    const navSection = document.querySelector("#shopify-section-wlk_mega_nav") || document.querySelector(".shopify-section.wlk-mega-section");
    const headerH = headerSection ? headerSection.offsetHeight : 0;
    const navVisible = window.matchMedia("(min-width: 990px)").matches;
    const navH = navVisible && navSection ? navSection.offsetHeight : 0;
    return Math.max(headerH + navH, 0);
  }

  function setDrawerTop() {
    setHeaderMetrics();
  }

  function closeAccordions(scope) {
    const area = scope || root;
    area.querySelectorAll("[data-accordion].is-open").forEach((acc) => setAccordion(acc, false));
  }

  function closeMega() {
    menuItems.forEach((item) => item.classList.remove("is-open"));
    closeAccordions(root.querySelector(".wlk-mega__nav"));
  }

  function syncOverlay() {
    if (!overlay) return;
    const on = drawerOpen || root.querySelector(".wlk-mega__item.is-open");
    overlay.classList.toggle("is-on", Boolean(on));
    overlay.classList.toggle("is-drawer", drawerOpen);
  }

  function closeMegaOnly() {
    closeMega();
    if (!drawerOpen) syncOverlay();
  }

  function openMega(item) {
    if (drawerOpen) closeDrawer();
    setDrawerTop();
    menuItems.forEach((el) => el.classList.toggle("is-open", el === item));
    syncOverlay();
  }

  function closePanels() {
    if (!drawer) return;
    drawer.querySelectorAll("[data-panel]").forEach((panel) => {
      panel.classList.remove("is-open");
    });
    drawer.classList.remove("is-panel");
    closeAccordions(drawer);
  }

  function openPanel(id) {
    if (!drawer) return;
    closePanels();
    const panel = drawer.querySelector(`[data-panel="${id}"]`);
    if (!panel) return;
    panel.hidden = false;
    drawer.classList.add("is-panel");
    requestAnimationFrame(() => {
      panel.classList.add("is-open");
      panel.scrollTop = 0;
    });
  }

  function openDrawer() {
    closeMega();
    const headerSection = document.querySelector(".section-header");
    if (headerSection) headerSection.classList.add("menu-open");
    setHeaderMetrics();
    const drawerTop = getDrawerTop();
    document.documentElement.style.setProperty("--wlk-drawer-top", `${drawerTop}px`);
    document.documentElement.style.setProperty("--wlk-overlay-top", `${drawerTop}px`);
    document.documentElement.style.setProperty("--wlk-pin-height", `${getPinHeight()}px`);
    document.documentElement.style.setProperty(
      "--wlk-scrollbar-width",
      `${Math.max(window.innerWidth - document.documentElement.clientWidth, 0)}px`
    );
    drawerOpen = true;
    if (drawer) {
      drawer.hidden = false;
      drawer.scrollTop = 0;
      const home = drawer.querySelector(".wlk-mega-drawer__home");
      if (home) home.scrollTop = 0;
      requestAnimationFrame(() => drawer.classList.add("is-open"));
    }
    drawerOpenBtns.forEach((btn) => {
      btn.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
    });
    document.documentElement.classList.add("is-wlk-drawer-open");
    syncOverlay();
  }

  function closeDrawer() {
    drawerOpen = false;
    closePanels();
    if (drawer) drawer.classList.remove("is-open");
    drawerOpenBtns.forEach((btn) => {
      btn.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
    });
    document.documentElement.classList.remove("is-wlk-drawer-open");
    document.documentElement.style.removeProperty("--wlk-scrollbar-width");
    const headerSection = document.querySelector(".section-header");
    if (headerSection) headerSection.classList.remove("menu-open");
    syncOverlay();
  }

  function closeAll() {
    closeMega();
    closeDrawer();
  }

  menuItems.forEach((item) => {
    const trigger = item.querySelector("[data-nav-trigger]");
    if (!trigger) return;

    item.addEventListener("mouseenter", () => {
      if (drawerOpen) return;
      clearTimeout(closeTimer);
      openMega(item);
    });
    item.addEventListener("mouseleave", () => {
      if (drawerOpen) return;
      closeTimer = setTimeout(closeMegaOnly, 180);
    });
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      if (item.classList.contains("is-open")) closeMegaOnly();
      else openMega(item);
    });
  });

  if (drawer) {
    drawer.querySelectorAll("[data-panel-open]").forEach((btn) => {
      btn.addEventListener("click", () => openPanel(btn.getAttribute("data-panel-open")));
    });
    drawer.querySelectorAll("[data-panel-close]").forEach((btn) => {
      btn.addEventListener("click", closePanels);
    });
  }

  function setAccordion(acc, open) {
    if (!acc) return;
    const btn = acc.querySelector("[data-accordion-toggle]");
    const panel = acc.querySelector(".wlk-mega-accordion__panel");
    acc.classList.toggle("is-open", open);
    if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
    if (panel) panel.hidden = !open;
  }

  function bindAccordionToggles(scope) {
    if (!scope) return;
    scope.querySelectorAll("[data-accordion-toggle]").forEach((btn) => {
      if (btn.dataset.wlkAccordionBound === "true") return;
      btn.dataset.wlkAccordionBound = "true";
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const acc = btn.closest("[data-accordion]");
        if (!acc) return;
        setAccordion(acc, !acc.classList.contains("is-open"));
      });
    });
  }

  bindAccordionToggles(root);
  bindAccordionToggles(drawer);

  drawerOpenBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (drawerOpen) closeDrawer();
      else openDrawer();
    });
  });
  if (drawerCloseBtn) drawerCloseBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeAll);
  document.documentElement.addEventListener(
    "click",
    (event) => {
      if (!drawerOpen) return;
      if (event.target !== document.documentElement) return;
      closeAll();
    },
    true
  );
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAll();
  });
  window.addEventListener("resize", setHeaderMetrics);
  window.addEventListener("scroll", setHeaderMetrics, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", setHeaderMetrics);
  }
  setHeaderMetrics();
})();
